import SplunkOtelWeb from '@splunk/otel-web';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Kermit } from "./components/PlaybookViewer/constants";
import {trace} from '@opentelemetry/api'

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/inconsolata";
import { OtelContext } from './components/PlaybookViewer/context';

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  SplunkOtelWeb.init({
    beaconUrl: "https://rum-ingest.us0.signalfx.com/v1/rum",
    rumAuth: "a5OVE71NXiRkCYxH34_Fbw",
    app: "SOAR Playbook Explorer",
    environment: "dev"
  });
} else if (process.env.NODE_ENV === 'production') {
  SplunkOtelWeb.init({
    beaconUrl: "https://rum-ingest.us0.signalfx.com/v1/rum",
    rumAuth: "a5OVE71NXiRkCYxH34_Fbw",
    app: "SOAR Playbook Explorer",
    environment: "prod",
    globalAttributes: {
      'globalplaybook': "insertplaybookurlhere"
   },
  });
}

console.log(Kermit)
const tracer = trace.getTracer('appModuleLoader');
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <OtelContext.Provider value={tracer}>
    <App />
    </OtelContext.Provider>
  </React.StrictMode>
);
